import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customers: null,
  waitingToVerifyCustomers: [],
};

const customersSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    takeAllCustomers: (state, action) => {
      state.customers = action.payload;
    },
    // takeOneCustomer: (state, action) => {
    //   state.sections = action.payload;
    // },
    takeWaitingToVerifyCustomers: (state, action) => {
      state.waitingToVerifyCustomers = action.payload;
    },
    editCustomer: (state, action) => {
      const customerIndex = state.customers.findIndex(
        (customer) => customer.id === action.payload.id
      );
      if (customerIndex !== -1) {
        state.customers[customerIndex] = action.payload;
      }
    },
    deleteCustomer: (state, action) => {
      const res = state.customers.filter(
        (customer) => customer.id !== action.payload
      );
      state.customers = res;
    },
  },
});

export const {
  takeAllCustomers,
  takeOneCustomer,
  takeWaitingToVerifyCustomers,
  editCustomer,
  deleteCustomer,
} = customersSlice.actions;

export default customersSlice.reducer;
